export enum AddressVerificationStatus {
    VERIFIED = 'verified',
    UNVERIFIED = 'unverified',
    OVERRIDDEN = 'overridden'
}

export enum AddressVerificationRef {
    WINDOW_REF = 'company.location.address_verification_status'
}